// EnumSelect: the ONE single-select dropdown for short fixed lists (direction, row mode, type, period, status ...).
// A thin wrapper over SingleFacet (the single source of the look: 34px trigger, popover, check glyph, keyboard); it adds
// only: search appears when the list has MORE than `searchThreshold` options (default 7), and options may be given as
// <option> children (same markup as the native select it replaces) or as `options` [{value,label,hint?,disabled?}].
// An <option value=""> (or `allLabel`) becomes the All row; without one there is no All row (a default value is shown
// as "Label: value"). `bare` = form mode (no "Label:" prefix), `required` / `disabled` supported.
// `size="sm"` is for dense inline use (btnStyle height).
import React from 'react';
import { useTranslation } from 'react-i18next';
import { SingleFacet } from './ShellFilterBar';

const txt = (c) => React.Children.toArray(c).map(x => (typeof x === 'string' || typeof x === 'number' ? String(x) : '')).join('');

export function optionsFromChildren(children) {
  const out = []; let allLabel; let placeholder;
  const walk = (kids, group) => React.Children.forEach(kids, (ch) => {
    if (!ch || !ch.type) return;
    if (ch.type === React.Fragment) { walk(ch.props.children, group); return; }
    if (ch.type === 'optgroup') { walk(ch.props.children, ch.props.label); return; }
    if (ch.type !== 'option') return;
    const { value, children: c, disabled, title } = ch.props;
    const v = value == null ? txt(c) : String(value);
    if (v === '') { if (disabled) placeholder = txt(c); else allLabel = txt(c); }   // a disabled blank option is a placeholder, not an All row
    else out.push({ value: v, label: txt(c), disabled, title, ...(group ? { group } : {}) });
  });
  walk(children);
  return { options: out, allLabel, placeholder };
}

export default function EnumSelect({ label, labelKey, value, onChange, options, allLabel, children, searchThreshold = 7, size, btnStyle, ...rest }) {
  const { t } = useTranslation('common');
  const fromKids = children ? optionsFromChildren(children) : null;
  const opts = options || fromKids?.options || [];
  const all = allLabel ?? fromKids?.allLabel;
  const ph = rest.placeholder ?? fromKids?.placeholder;
  return (
    <SingleFacet label={labelKey ? t('enumSel.' + labelKey) : label} options={opts} value={value == null ? '' : String(value)} onChange={onChange}
      allLabel={all} allowAll={all != null} dflt={all != null ? '' : opts[0]?.value} searchAbove={searchThreshold}
      btnStyle={size === 'sm' ? { height: 28, ...btnStyle } : btnStyle} {...rest} placeholder={ph} />
  );
}
export { EnumSelect };
